<template>
	<div>

		<v-container grid-list-xs fluid class="pa-0">

			<v-layout
				row wrap
				v-if="form.parameters.hasOwnProperty(parameters_names.job_title)">
				<v-text-field
					outline
					@change="emitChange()"
					v-model="form.parameters[parameters_names.job_title]"
					class="dense_input">
					<template v-slot:label>
						Job Title
						<span v-if="parameters[parameters_names.job_title].required" class="ml-1">
							*
						</span>
					</template>
				</v-text-field>
			</v-layout>

			<v-layout
				row wrap
				v-if="form.parameters.hasOwnProperty(parameters_names.output_folder)">
				<v-text-field
					outline
					:ref="parameters_names.output_folder"
					@change="pathCleaner(parameters_names.output_folder)"
					v-model="form.parameters[parameters_names.output_folder]"
					:prefix="getFileBasename(form.parameters[parameters_names.output_folder])"
					class="file-input dense_input"
					:append-icon="'folder_open'"
					@click:append="showFileExplorer(parameters[parameters_names.output_folder], null)">
					<template v-slot:label>
						Output Folder
						<span v-if="parameters[parameters_names.output_folder].required" class="ml-1">
							*
						</span>
					</template>
				</v-text-field>
			</v-layout>

			<v-layout row wrap>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.audio_config)" shrink>
					<v-select
						outline
						class="dense_input"
						@change="onAudioConfChange($event)"
						:items="parameters[parameters_names.audio_config].choices"
						v-model="form.parameters[parameters_names.audio_config]"
						label="Audio Config">
					</v-select>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.downmix_output_config)" shrink>
					<v-select
						outline
						class="dense_input"
						@change="emitChange()"
						:items="parameters[parameters_names.downmix_output_config].choices"
						v-model="form.parameters[parameters_names.downmix_output_config]"
						label="Downmix Output Config">
					</v-select>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.upmix_output_config)" shrink>
					<v-select
						outline
						class="dense_input"
						@change="emitChange()"
						:items="parameters[parameters_names.upmix_output_config].choices"
						v-model="form.parameters[parameters_names.upmix_output_config]"
						label="Upmix Output Config">
					</v-select>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.varispeed_config)" shrink>
					<v-select
						outline
						class="dense_input"
						@change="emitChange()"
						:items="parameters[parameters_names.varispeed_config].choices"
						v-model="form.parameters[parameters_names.varispeed_config]"
						label="Varispeed Config">
					</v-select>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.qt_profile)" shrink>
					<v-select
						outline
						class="dense_input"
						@change="emitChange()"
						:items="parameters[parameters_names.qt_profile].choices"
						v-model="form.parameters[parameters_names.qt_profile]"
						label="QT Profile">
					</v-select>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.fps)" shrink>
					<v-select
						outline
						class="dense_input"
						@change="emitChange()"
						:items="parameters[parameters_names.fps].choices"
						v-model="form.parameters[parameters_names.fps]"
						label="FPS">
					</v-select>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.measurement_only)" grow>
					<v-checkbox
						hide-details
						label="Measurement Only"
						color="primary"
						class="ml-3"
						@change="emitChange()"
						v-model="form.parameters[parameters_names.measurement_only]">
					</v-checkbox>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.harmonize)" grow>
					<v-checkbox
						hide-details
						label="Harmonize"
						color="primary"
						class="ml-3"
						@change="emitChange()"
						v-model="form.parameters[parameters_names.harmonize]">
					</v-checkbox>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.dialogue_measurement)" shrink>
					<v-checkbox
						hide-details
						label="Dialogue Measurement"
						color="primary"
						class="ml-3"
						@change="emitChange()"
						v-model="form.parameters[parameters_names.dialogue_measurement]">
					</v-checkbox>
				</v-flex>
				<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.r128_measurement)" shrink>
					<v-checkbox
						hide-details
						label="R128 Measurement"
						color="primary"
						class="ml-3"
						@change="emitChange()"
						v-model="form.parameters[parameters_names.r128_measurement]">
					</v-checkbox>
				</v-flex>
			</v-layout>

			<v-layout
				row wrap
				v-if="form.parameters.hasOwnProperty(parameters_names.audio_tracks)">
				<table id="audio-table" v-if="form.parameters[parameters_names.audio_tracks].length">
					<colgroup>
						<col style="width: 40px">
						<col>
						<col style="width: 200px">
					</colgroup>
					<thead>
						<tr>
							<td class="text-center">
								<v-btn
									flat icon
									color="warning"
									class="ma-0"
									:disabled="!form.parameters[parameters_names.audio_tracks][0].path"
									@click="emptyTracks('all')">
									<v-icon>close</v-icon>
								</v-btn>
							</td>
							<td>
								<span class="subheading">Audio Tracks</span>
							</td>
							<td class="px-2">
								<v-btn
									small
									block
									color="success"
									:disabled="!form.parameters[parameters_names.audio_tracks][0].path"
									:loading="probing"
									@click="validateTracks()">
									Validation
								</v-btn>
							</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(track, i) in form.parameters[parameters_names.audio_tracks]"
							:key="'track_' + i">
							<td class="text-center">
								<v-btn
									flat icon
									color="warning"
									class="ma-0"
									:disabled="!track.path"
									@click="emptyTracks(i)">
									<v-icon>close</v-icon>
								</v-btn>
							</td>
							<td>
								<v-text-field
									readonly
									outline
									:ref="parameters_names.audio_tracks"
									v-model="track.path"
									:prefix="getFileBasename(track.path)"
									class="file-input dense_input"
									:append-icon="'folder_open'"
									@click:append="showFileExplorer(parameters[parameters_names.audio_tracks], i)">
									<template v-slot:label>
										Audio Tracks
										<span v-if="parameters[parameters_names.audio_tracks].required" class="ml-1">
											*
										</span>
									</template>
									<template v-slot:prepend>
										<span v-if="audioconfig_mapping.hasOwnProperty(form.parameters[parameters_names.audio_config])">
											{{ audioconfig_mapping[form.parameters[parameters_names.audio_config]][i] }}
										</span>
									</template>
								</v-text-field>
							</td>
							<td class="pa-1 text-center">
								<div v-if="track.valid === true"
									class="success--text text--lighten-1">
									<span v-safe-html="track.probe"></span>
								</div>
								<div v-else-if="track.valid === false"
									class="error--text font-weight-bold">
									<span v-safe-html="track.probe"></span>
								</div>
								<div v-else class="warning--text subheading">- - -</div>
							</td>
						</tr>
					</tbody>
				</table>
			</v-layout>

		</v-container>

		<Explorer
			v-if="explorer.show"
			:assetType="explorer.asset_type"
			:multiselect="false"
			:default_folder="explorer.default_value"
			:return_dir_filelist="explorer.return_dir_filelist"
			toolbarTitle="Selectionnez des assets présents sur le filesystem"
			@close="onExplorerClose()"
			@selectedAssets="onSelectedAssets($event)">
		</Explorer>

		<v-dialog
			v-model="check_path_loader.active"
			hide-overlay
			persistent
			max-width="fit-content">
			<v-card color="primary">
				<v-card-text class="text-center">
					<span class="color--text headline">
						Check Path
					</span>
					<br>
					<span class="color--text subheading">
						{{ check_path_loader.path }}
					</span>
					<v-progress-linear
						indeterminate
						color="color"
						class="mb-0" />
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import Explorer from '@/components/modal_explorer.vue'
import Path from 'path'
export default {
	props: [ 'wf_data', 'debug', 'visible', 'details', 'param' ],
	components: { Explorer },
	data () {
		return {
			explorer: {
				show: false,
				asset_type: null,
				destination_key: null,
				default_value: null,
				return_dir_filelist: false
			},
			form: {
				isValid: false,
				parameters: {},
				jobdescriptorID: this.wf_data.descriptor_id,
				jobDescriptorVersion: this.wf_data.version_number
			},
			probing: false,
			probe_status: null,
			parameters: {},
			check_path_loader: {
				active: false,
				path: ''
			},
			audioconfig_mapping: {
				'1.0': ['M'],
				'2.0': ['LT', 'RT'],
				'2.0 (single file)': ['LTRT'],
				'5.1': ['L', 'R', 'C', 'LFE', 'LS', 'RS'],
				'7.1': ['L', 'R', 'C', 'LFE', 'LS', 'RS', 'LSR', 'RSR'],
				'9.1': ['L', 'R', 'C', 'LFE', 'LS', 'RS', 'LSR', 'RSR', 'LTS', 'RTS'],
				'2.0 + 5.1': ['LT', 'RT', 'L', 'R', 'C', 'LFE', 'LS', 'RS'],
				'5.1 + 2.0': ['L', 'R', 'C', 'LFE', 'LS', 'RS', 'LT', 'RT']
			},
			parameters_names: {
				audio_tracks: null,
				job_title: null,
				audio_config: null,
				varispeed_config: null,
				downmix_output_config: null,
				upmix_output_config: null,
				output_folder: null,
				measurement_only: null,
				harmonize: null,
				qt_profile: null,
				fps: null
			},
			default_output_folder: '/media/DATA/1305j552_calcul/maestro/audiotools/'
		}
	},
	watch: {
		wf_data () {
			this.setForm()
			this.$emit('modal_width', '1200px')
		},
		visible (val) {
			if (val) {
				if (this.param) {
					if (this.param.type.indexOf('folder') > -1) {
						if (this.form.parameters.hasOwnProperty(this.parameters_names.output_folder)) {
							this.form.parameters[this.parameters_names.output_folder] = this.param.value + '/'
						}
					}
				}
				this.emitChange()
			}
		}
	},
	methods: {
		setForm () {
			this.form.parameters = {}
			this.form.jobdescriptorID = this.wf_data.descriptor_id
			this.form.jobDescriptorVersion = this.wf_data.version_number
			this.wf_data.parameters.map(param => {
				if (['Audio Tracks', 'audio_tracks'].indexOf(param.name) > -1) {
					this.parameters_names.audio_tracks = param.name
				} else if (['Job Title', 'job_title'].indexOf(param.name) > -1) {
					this.parameters_names.job_title = param.name
				} else if (['Audio Config', 'audio_config'].indexOf(param.name) > -1) {
					this.parameters_names.audio_config = param.name
				} else if (['Varispeed Config', 'varispeed_config'].indexOf(param.name) > -1) {
					this.parameters_names.varispeed_config = param.name
				} else if (['Downmix Output Config', 'downmix_output_config'].indexOf(param.name) > -1) {
					this.parameters_names.downmix_output_config = param.name
				} else if (['Upmix Output Config', 'upmix_output_config'].indexOf(param.name) > -1) {
					this.parameters_names.upmix_output_config = param.name
				} else if (['Output Folder', 'output_folder'].indexOf(param.name) > -1) {
					this.parameters_names.output_folder = param.name
				} else if (['Measurement Only', 'measurement_only'].indexOf(param.name) > -1) {
					this.parameters_names.measurement_only = param.name
				} else if (['Harmonize', 'harmonize'].indexOf(param.name) > -1) {
					this.parameters_names.harmonize = param.name
				} else if (['QT Profile', 'qt_profile'].indexOf(param.name) > -1) {
					this.parameters_names.qt_profile = param.name
				} else if (['Fps', 'fps'].indexOf(param.name) > -1) {
					this.parameters_names.fps = param.name
				} else if (['Dialogue Measurement', 'dialogue_measurement'].indexOf(param.name) > -1) {
					this.parameters_names.dialogue_measurement = param.name
				} else if (['R128 Measurement', 'r128_measurement'].indexOf(param.name) > -1) {
					this.parameters_names.r128_measurement = param.name
				}
				let defaultValue = ''
				if (param.type === 'multi-char') defaultValue = []
				if (param.default !== '') defaultValue = param.default
				if (this.details.hasOwnProperty(param.name)) {
					defaultValue = this.details[param.name]
				}
				if (['Output Folder', 'output_folder'].indexOf(param.name) > -1) {
					defaultValue = this.default_output_folder
				}
				this.$set(this.form.parameters, param.name, defaultValue)
				this.parameters[param.name] = param
				if (['Audio Config', 'audio_config'].indexOf(param.name) > -1 && defaultValue) {
					this.onAudioConfChange(defaultValue)
				}
			})
			if (this.param) {
				if (this.param.type) {
					if (this.param.type.indexOf('folder') > -1) {
						if (this.form.parameters.hasOwnProperty(this.parameters_names.output_folder)) {
							this.form.parameters[this.parameters_names.output_folder] = this.param.value + '/'
						}
					}
				}
			}
			this.emitChange()
		},
		showFileExplorer (param, index) {
			if (param.name === this.parameters_names.output_folder) {
				this.explorer.asset_type = 'folder'
			} else if (param.name === this.parameters_names.audio_tracks) {
				this.explorer.asset_type = 'file'
				if (index === 0 && this.form.parameters[this.parameters_names.audio_tracks].length > 1) {
					this.explorer.return_dir_filelist = true
				}
			} else {
				this.explorer.asset_type = null
			}
			this.explorer.default_value = null
			if (param.default) {
				this.explorer.default_value = this.$paths.maestroToUNC(param.default)
			}
			this.explorer.destination_key = param.name
			this.explorer.destination_index = index
			this.explorer.show = true
		},
		onExplorerClose () {
			this.explorer.show = false
			this.explorer.asset_type = null
			this.explorer.destination_key = null
			this.explorer.destination_index = null
			this.explorer.return_dir_filelist = false
		},
		onSelectedAssets (evt) {
			if (this.explorer.return_dir_filelist === false) {
				let maestroPath = this.$paths.UNCToMaestro(evt.path)
				if (evt.type === 'folder') {
					maestroPath = maestroPath + '/'
				}
				if (this.explorer.destination_key === this.parameters_names.output_folder) {
					this.form.parameters[this.parameters_names.output_folder] = maestroPath
				} else if (this.explorer.destination_key === this.parameters_names.audio_tracks) {
					this.form.parameters[this.parameters_names.audio_tracks][this.explorer.destination_index].path = maestroPath
					this.form.parameters[this.parameters_names.audio_tracks][this.explorer.destination_index].probe = ''
					this.form.parameters[this.parameters_names.audio_tracks][this.explorer.destination_index].valid = null
				}
			} else {
				let maestroPath = this.$paths.UNCToMaestro(evt.selected.path)
				this.form.parameters[this.parameters_names.audio_tracks][this.explorer.destination_index].path = maestroPath
				this.form.parameters[this.parameters_names.audio_tracks][this.explorer.destination_index].probe = ''
				this.form.parameters[this.parameters_names.audio_tracks][this.explorer.destination_index].valid = null
				let _arr = evt.selected.path.split(/[._]/)
				let baseEndIndex = evt.selected.path.lastIndexOf(_arr[_arr.length - 2])
				let base = evt.selected.path.substring(0, baseEndIndex)

				let selectedSuffixIndex = _arr.length - 2
				let selectedSuffix = _arr[selectedSuffixIndex]
				if (selectedSuffix) selectedSuffix = selectedSuffix.toUpperCase()

				let selectedExt = _arr[_arr.length - 1]
				if (selectedExt) selectedExt = selectedExt.toUpperCase()

				evt.filelist.map(file => {
					if (file.indexOf(base) === 0) {
						if (selectedSuffix === 'L') {
							let fileExt = file.split(/[._]/)[file.split(/[._]/).length - 1]
							if (fileExt) fileExt = fileExt.toUpperCase()
							if (fileExt === selectedExt) {
								let fileSuffix = file.split(/[._]/)[selectedSuffixIndex]
								if (fileSuffix) fileSuffix = fileSuffix.toUpperCase()
								if (fileSuffix === 'R' &&
									this.form.parameters[this.parameters_names.audio_tracks][1]) {
									let maestroPath = this.$paths.UNCToMaestro(file)
									this.form.parameters[this.parameters_names.audio_tracks][1].path = maestroPath
									this.form.parameters[this.parameters_names.audio_tracks][1].probe = ''
									this.form.parameters[this.parameters_names.audio_tracks][1].valid = null
								}
								if (fileSuffix === 'C' &&
									this.form.parameters[this.parameters_names.audio_tracks][2]) {
									let maestroPath = this.$paths.UNCToMaestro(file)
									this.form.parameters[this.parameters_names.audio_tracks][2].path = maestroPath
									this.form.parameters[this.parameters_names.audio_tracks][2].probe = ''
									this.form.parameters[this.parameters_names.audio_tracks][2].valid = null
								}
								if (fileSuffix === 'LFE' &&
									this.form.parameters[this.parameters_names.audio_tracks][3]) {
									let maestroPath = this.$paths.UNCToMaestro(file)
									this.form.parameters[this.parameters_names.audio_tracks][3].path = maestroPath
									this.form.parameters[this.parameters_names.audio_tracks][3].probe = ''
									this.form.parameters[this.parameters_names.audio_tracks][3].valid = null
								}
								if (fileSuffix === 'SW' &&
									this.form.parameters[this.parameters_names.audio_tracks][3]) {
									let maestroPath = this.$paths.UNCToMaestro(file)
									this.form.parameters[this.parameters_names.audio_tracks][3].path = maestroPath
									this.form.parameters[this.parameters_names.audio_tracks][3].probe = ''
									this.form.parameters[this.parameters_names.audio_tracks][3].valid = null
								}
								if (fileSuffix === 'LS' &&
									this.form.parameters[this.parameters_names.audio_tracks][4]) {
									let maestroPath = this.$paths.UNCToMaestro(file)
									this.form.parameters[this.parameters_names.audio_tracks][4].path = maestroPath
									this.form.parameters[this.parameters_names.audio_tracks][4].probe = ''
									this.form.parameters[this.parameters_names.audio_tracks][4].valid = null
								}
								if (fileSuffix === 'RS' &&
									this.form.parameters[this.parameters_names.audio_tracks][5]) {
									let maestroPath = this.$paths.UNCToMaestro(file)
									this.form.parameters[this.parameters_names.audio_tracks][5].path = maestroPath
									this.form.parameters[this.parameters_names.audio_tracks][5].probe = ''
									this.form.parameters[this.parameters_names.audio_tracks][5].valid = null
								}
								if (this.form.parameters[this.parameters_names.audio_config] === '5.1 + 2.0') {
									if (fileSuffix === 'LT' &&
										this.form.parameters[this.parameters_names.audio_tracks][6]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][6].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][6].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][6].valid = null
									}
									if (fileSuffix === 'RT' &&
										this.form.parameters[this.parameters_names.audio_tracks][7]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][7].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][7].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][7].valid = null
									}
								} else if (this.form.parameters[this.parameters_names.audio_config] === '7.1' ||
									this.form.parameters[this.parameters_names.audio_config] === '9.1') {
									if (fileSuffix === 'LSS' &&
										this.form.parameters[this.parameters_names.audio_tracks][4]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][4].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][4].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][4].valid = null
									}
									if (fileSuffix === 'RSS' &&
										this.form.parameters[this.parameters_names.audio_tracks][5]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][5].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][5].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][5].valid = null
									}
									if (fileSuffix === 'LSR' &&
										this.form.parameters[this.parameters_names.audio_tracks][6]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][6].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][6].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][6].valid = null
									}
									if (fileSuffix === 'RSR' &&
										this.form.parameters[this.parameters_names.audio_tracks][7]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][7].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][7].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][7].valid = null
									}
									if (this.form.parameters[this.parameters_names.audio_config] === '9.1') {
										if (fileSuffix === 'LTS' &&
											this.form.parameters[this.parameters_names.audio_tracks][8]) {
											let maestroPath = this.$paths.UNCToMaestro(file)
											this.form.parameters[this.parameters_names.audio_tracks][8].path = maestroPath
											this.form.parameters[this.parameters_names.audio_tracks][8].probe = ''
											this.form.parameters[this.parameters_names.audio_tracks][8].valid = null
										}
										if (fileSuffix === 'RTS' &&
											this.form.parameters[this.parameters_names.audio_tracks][9]) {
											let maestroPath = this.$paths.UNCToMaestro(file)
											this.form.parameters[this.parameters_names.audio_tracks][9].path = maestroPath
											this.form.parameters[this.parameters_names.audio_tracks][9].probe = ''
											this.form.parameters[this.parameters_names.audio_tracks][9].valid = null
										}
									}
								}
							}
						} else if (selectedSuffix === 'LT') {
							let fileExt = file.split(/[._]/)[file.split(/[._]/).length - 1]
							if (fileExt) fileExt = fileExt.toUpperCase()
							if (fileExt === selectedExt) {
								let fileSuffix = file.split(/[._]/)[selectedSuffixIndex]
								if (fileSuffix) fileSuffix = fileSuffix.toUpperCase()
								if (fileSuffix === 'RT' &&
									this.form.parameters[this.parameters_names.audio_tracks][1]) {
									let maestroPath = this.$paths.UNCToMaestro(file)
									this.form.parameters[this.parameters_names.audio_tracks][1].path = maestroPath
									this.form.parameters[this.parameters_names.audio_tracks][1].probe = ''
									this.form.parameters[this.parameters_names.audio_tracks][1].valid = null
								}
								if (this.form.parameters[this.parameters_names.audio_config] === '2.0 + 5.1') {
									if (fileSuffix === 'L' &&
										this.form.parameters[this.parameters_names.audio_tracks][2]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][2].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][2].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][2].valid = null
									}
									if (fileSuffix === 'R' &&
										this.form.parameters[this.parameters_names.audio_tracks][3]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][3].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][3].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][3].valid = null
									}
									if (fileSuffix === 'C' &&
										this.form.parameters[this.parameters_names.audio_tracks][4]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][4].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][4].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][4].valid = null
									}
									if (fileSuffix === 'LFE' &&
										this.form.parameters[this.parameters_names.audio_tracks][5]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][5].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][5].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][5].valid = null
									}
									if (fileSuffix === 'SW' &&
										this.form.parameters[this.parameters_names.audio_tracks][5]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][5].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][5].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][5].valid = null
									}
									if (fileSuffix === 'LS' &&
										this.form.parameters[this.parameters_names.audio_tracks][6]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][6].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][6].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][6].valid = null
									}
									if (fileSuffix === 'RS' &&
										this.form.parameters[this.parameters_names.audio_tracks][7]) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][7].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][7].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][7].valid = null
									}
								}
							}
						} else if (Number.isInteger(parseInt(selectedSuffix))) {
							let selectedInt = parseInt(selectedSuffix)
							let fileExt = file.split(/[._]/)[file.split(/[._]/).length - 1]
							if (fileExt) fileExt = fileExt.toUpperCase()
							if (fileExt === selectedExt) {
								let fileSuffix = file.split(/[._]/)[selectedSuffixIndex]
								if (Number.isInteger(parseInt(fileSuffix))) {
									let fileInt = parseInt(fileSuffix)
									if (selectedInt < fileInt && (fileInt - selectedInt) <= this.form.parameters[this.parameters_names.audio_tracks].length - 1) {
										let maestroPath = this.$paths.UNCToMaestro(file)
										this.form.parameters[this.parameters_names.audio_tracks][fileInt - selectedInt].path = maestroPath
										this.form.parameters[this.parameters_names.audio_tracks][fileInt - selectedInt].probe = ''
										this.form.parameters[this.parameters_names.audio_tracks][fileInt - selectedInt].valid = null
									}
								}
							}
						}
					}
				})
			}
			this.emitChange()
			this.onExplorerClose()
		},
		pathCleaner (paramName) {
			let path = this.form.parameters[paramName]
			path = path.trim()

			// Clean double quotes from windows paste
			if (path[0] === '"') path = path.slice(1)
			if (path[path.length - 1] === '"') path = path.slice(0, path.length - 1)
			// Clean windows backslashes
			let newPath = path.replace(/\\/g, '/')
			if (newPath.toLowerCase().indexOf('/media/data') > -1) {
				newPath = this.$paths.maestroToUNC(newPath)
			}
			if (!newPath) {
				this.form.isValid = false
				this.emitChange()
				return
			}
			let maestroPath = this.$paths.UNCToMaestro(newPath)
			if (maestroPath[maestroPath.length - 1] !== '/') maestroPath += '/'
			this.$set(this.form.parameters, paramName, maestroPath)

			this.check_path_loader.active = true
			this.check_path_loader.path = newPath
			this.$ApiNexus.exist(maestroPath)
				.then(result => {
					if (!result.data) throw new Error('le chemin ne semble pas exister')
				})
				.catch(error => {
					this.$refs[paramName].badInput = true
					this.$refs[paramName].errorBucket.push(
						error.message
					)
					this.form.isValid = false
				})
				.finally(() => {
					this.check_path_loader.active = false
					this.check_path_loader.path = ''
					this.emitChange()
				})
		},
		audioConfToNbChannels (conf) {
			let nbCh = 0
			if (this.audioconfig_mapping.hasOwnProperty(conf)) {
				nbCh = this.audioconfig_mapping[conf].length
			}
			return nbCh
		},
		emptyTracks (index) {
			if (index === 'all') {
				for (let i = 0; i < this.form.parameters[this.parameters_names.audio_tracks].length; i++) {
					this.form.parameters[this.parameters_names.audio_tracks][i] = {
						path: '',
						valid: null,
						probe: ''
					}
				}
			} else {
				this.form.parameters[this.parameters_names.audio_tracks][index] = {
					path: '',
					valid: null,
					probe: ''
				}
			}
			this.$forceUpdate()
			this.emitChange()
		},
		onAudioConfChange (conf) {
			let nbCh = this.audioConfToNbChannels(conf)
			this.form.parameters[this.parameters_names.audio_tracks].length = nbCh
			for (let i = 0; i < nbCh; i++) {
				if (!this.form.parameters[this.parameters_names.audio_tracks][i]) {
					this.form.parameters[this.parameters_names.audio_tracks][i] = {
						path: '',
						valid: null,
						probe: ''
					}
				}
			}
			this.emitChange()
		},
		getFileBasename (filepath) {
			try {
				let basename = Path.basename(filepath)
				if (basename) return './' + Path.basename(filepath)
				return ''
			} catch (error) {
				return ''
			}
		},
		probeFile (filepath) {
			return new Promise((resolve, reject) => {
				this.$ApiNexus.ffprobe(filepath)
					.then(result => {
						resolve(result.data.detail)
					})
					.catch(error => {
						console.error('probeFile error', error.response)
						reject(error)
					})
			})
		},
		async validateTracks () {
			this.probing = true
			this.probe_status = null
			let prevDuration = null
			for (let i = 0; i < this.form.parameters[this.parameters_names.audio_tracks].length; i++) {
				const track = this.form.parameters[this.parameters_names.audio_tracks][i]
				if (track.path) {
					try {
						let trackValidity = true
						let trackInValidityReason = []
						let uncPath = this.$paths.maestroToUNC(track.path)
						let probe = await this.probeFile(uncPath)
						if (probe.video) {
							track.valid = false
							this.form.isValid = false
							track.probe = 'Stream not audio only'
						} else if (probe.audio.length === 0) {
							track.valid = false
							this.form.isValid = false
							track.probe = 'No audio stream found'
						} else {
							for (const stream of probe.audio) {
								let nb_ch = stream.channels
								if (this.form.parameters[this.parameters_names.audio_config] === '2.0 (single file)') {
									if (nb_ch !== 2) {
										trackValidity = false
										this.form.isValid = false
										trackInValidityReason.push('Nb channel != 2')
									}
								} else {
									if (nb_ch !== 1) {
										trackValidity = false
										this.form.isValid = false
										trackInValidityReason.push('Nb channel > 1')
									}
								}
								let bitdepth = stream.bits_per_sample
								let samplerate = stream.sample_rate
								let duration = stream.duration
								if (prevDuration && duration !== prevDuration) {
									trackValidity = false
									this.form.isValid = false
									trackInValidityReason.push('Durée différente')
								}
								prevDuration = duration
								let probeString = [
									`${nb_ch}ch`,
									`${bitdepth}bits`,
									`${samplerate}hz`,
									this.$time.secondsToTcMs(duration),
									`<br>${trackInValidityReason.join('<br>')}`
								]
								probeString = probeString.join(' ')
								track.valid = trackValidity
								track.probe = probeString
							}
						}
					} catch (error) {
						track.valid = false
						this.form.isValid = false
						track.probe = error.response.data
					}
					this.$forceUpdate()
				}
			}
			this.probing = false
			this.emitChange()
		},
		getOutputForm () {
			let form = {
				isValid: true,
				parameters: {},
				jobdescriptorID: this.form.jobdescriptorID,
				jobDescriptorVersion: this.form.jobDescriptorVersion
			}

			// Set & Check output folder
			if (this.form.parameters.hasOwnProperty(this.parameters_names.output_folder)) {
				form.parameters[this.parameters_names.output_folder] = this.form.parameters[this.parameters_names.output_folder]
				if (!this.form.parameters[this.parameters_names.output_folder]) form.isValid = false
				if (this.$refs[this.parameters_names.output_folder]) {
					if (this.$refs[this.parameters_names.output_folder].badInput) form.isValid = false
				}
			}

			// Set Measurement Only
			if (this.form.parameters.hasOwnProperty(this.parameters_names.measurement_only)) {
				form.parameters[this.parameters_names.measurement_only] = this.form.parameters[this.parameters_names.measurement_only]
			}

			// Set R128 Measurement
			if (this.form.parameters.hasOwnProperty(this.parameters_names.r128_measurement)) {
				form.parameters[this.parameters_names.r128_measurement] = this.form.parameters[this.parameters_names.r128_measurement]
			}

			// Set Dialog Measurement
			if (this.form.parameters.hasOwnProperty(this.parameters_names.dialogue_measurement)) {
				form.parameters[this.parameters_names.dialogue_measurement] = this.form.parameters[this.parameters_names.dialogue_measurement]
			}

			// Set Harmonize
			if (this.form.parameters.hasOwnProperty(this.parameters_names.harmonize)) {
				form.parameters[this.parameters_names.harmonize] = this.form.parameters[this.parameters_names.harmonize]
			}

			// Set Job Title
			if (this.form.parameters.hasOwnProperty(this.parameters_names.job_title)) {
				form.parameters[this.parameters_names.job_title] = this.form.parameters[this.parameters_names.job_title]
			}

			// Set & Check audio config
			if (this.form.parameters.hasOwnProperty(this.parameters_names.audio_config)) {
				form.parameters[this.parameters_names.audio_config] = this.form.parameters[this.parameters_names.audio_config]
				if (this.parameters[this.parameters_names.audio_config].choices.indexOf(form.parameters[this.parameters_names.audio_config]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check Downmix Output Config
			if (this.form.parameters.hasOwnProperty(this.parameters_names.downmix_output_config)) {
				form.parameters[this.parameters_names.downmix_output_config] = this.form.parameters[this.parameters_names.downmix_output_config]
				if (this.parameters[this.parameters_names.downmix_output_config].choices.indexOf(form.parameters[this.parameters_names.downmix_output_config]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check Upmix Output Config
			if (this.form.parameters.hasOwnProperty(this.parameters_names.upmix_output_config)) {
				form.parameters[this.parameters_names.upmix_output_config] = this.form.parameters[this.parameters_names.upmix_output_config]
				if (this.parameters[this.parameters_names.upmix_output_config].choices.indexOf(form.parameters[this.parameters_names.upmix_output_config]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check Varispeed Config
			if (this.form.parameters.hasOwnProperty(this.parameters_names.varispeed_config)) {
				form.parameters[this.parameters_names.varispeed_config] = this.form.parameters[this.parameters_names.varispeed_config]
				if (this.parameters[this.parameters_names.varispeed_config].choices.indexOf(form.parameters[this.parameters_names.varispeed_config]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check QT Profile
			if (this.form.parameters.hasOwnProperty(this.parameters_names.qt_profile)) {
				form.parameters[this.parameters_names.qt_profile] = this.form.parameters[this.parameters_names.qt_profile]
				if (this.parameters[this.parameters_names.qt_profile].choices.indexOf(form.parameters[this.parameters_names.qt_profile]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check fpss
			if (this.form.parameters.hasOwnProperty(this.parameters_names.fps)) {
				form.parameters[this.parameters_names.fps] = this.form.parameters[this.parameters_names.fps]
				if (this.parameters[this.parameters_names.fps].choices.indexOf(form.parameters[this.parameters_names.fps]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check audio tracks
			if (this.form.parameters.hasOwnProperty(this.parameters_names.audio_tracks)) {
				let tracks = []
				this.form.parameters[this.parameters_names.audio_tracks].map(track => {
					if (track.path) {
						tracks.push(track.path)
						if (!track.valid) form.isValid = false
					} else {
						form.isValid = false
					}
				})
				form.parameters[this.parameters_names.audio_tracks] = tracks.join(', ')
			}

			return form
		},
		emitChange () {
			let outputForm = this.getOutputForm()
			this.$emit('change', [outputForm])
		}
	},
	mounted () {
		this.setForm()
		this.$emit('modal_width', '1200px')
	}
}
</script>

<style scoped lang="stylus">
.file-input
	>>>.v-input__prepend-outer
		width: 30px
		font-size: 14px
		margin-top: 14px
		justify-content: flex-end
	>>>.v-text-field__slot
		.v-text-field__prefix
			font-size: 14px
			font-weight: 600
			margin: 2px 2px 0 6px
			white-space: nowrap
		input
			font-size: 12px !important

#audio-table
	width: 100%
	margin-top: 16px
	thead
		td
			background-color: var(--v-background-darken1)
	tbody
		tr
			border-top: 1px solid var(--v-background-lighten1)

.dense_input
	>>>.v-input__append-inner
		padding: 0 4px
	>>>.v-text-field__details
		padding: 0 0.1em
		margin-bottom: 0

</style>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_audiotools_audiofiles.vue